"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createD2CMessage = exports.C2DMessage = exports.BaseTelemetryMessage = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const date_1 = require("../../../date");
const message_1 = require("./message");
exports.NAMESPACE = 'Culligan.Protocol.V3.Telemetry';
exports.BaseTelemetryMessage = effect_1.Schema.Struct({
    time: date_1.Timestamp,
}).annotations({
    identifier: `${exports.NAMESPACE}.BaseTelemetryMessage`,
});
exports.C2DMessage = (0, message_1.createMessage)('command', effect_1.Schema.Struct({ command: effect_1.Schema.tag('telemetry.get') })).annotations({
    title: 'Telemetry Message',
    description: 'A Cloud-To-Device message related to telemetry',
    identifier: `${exports.NAMESPACE}.C2DMessage`,
});
const createD2CMessage = (telemetry) => (0, message_1.createMessage)('telemetry', exports.BaseTelemetryMessage.pipe(effect_1.Schema.extend(effect_1.Schema.partialWith(telemetry, { exact: true })))).annotations({
    title: 'Telemetry Message',
    description: 'A Device-To-Cloud message on the "telemetry" channel',
});
exports.createD2CMessage = createD2CMessage;
//# sourceMappingURL=telemetry.js.map